import api, { apiPrefix } from './Api';
import { Popup, popupFromResponse } from '../interfaces/Popup/Popup';

const popupApiPrefix = `${apiPrefix}/popups`;

export const getPopups = async (): Promise<Popup[]> => {
  const response = await api.get(popupApiPrefix);

  return (response.data?.data ?? []).map(popupFromResponse);
};
